export default {"src":"/_next/static/media/search.fc1ea8c9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};